import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-servicos',
    templateUrl: './servicos.component.html',
    styleUrls: ['./servicos.component.less'],
    standalone: false
})
export class ServicosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
